/* eslint-disable no-undef */
import $ from "jquery";
import { validationRequired } from "../../utils/util-validationForm";

const ContactForm = () => {
    const init = () => {
        ajax();
    };

    const ajax = () => {
        $(document).on("click", "#btn_Contact__Form", function () {
            const validationRequired_ = validationRequired($(this));

            if (!validationRequired_) return;

            let data = {
                action: themeObj.contact.action,
                nonce: themeObj.contact.nonce,
                name: $("#name").val(),
                email: $("#email").val(),
                phone: $("#phone").val(),
                message: $("#message").val(),
            };

            if (
                data.name != "" ||
                data.email != "" ||
                data.phone != "" ||
                data.message != ""
            ) {
                $.ajax({
                    type: "POST",
                    url: themeObj.ajaxUrl,
                    data: data,
                })
                    .done(() => {
                        // alert(response.data.message);
                        $(
                            "#popup-notification-success_contact_form",
                        ).toggleClass("active");
                    })
                    .fail((response) => {
                        console.error(response);
                    });
            } else {
                $("#popup-notification-failed_contact_form").toggleClass(
                    "active",
                );
            }
        });
    };

    init();
};

try {
    ContactForm();
} catch (error) {
    console.error("ContactForm", error);
}
